import React from "react"
import PropTypes from "prop-types"
import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
} from "react-share"

import { Button, Icon } from "semantic-ui-react"

const ShareFooter = ({ socialConfig, tags }) => (
  <>
    <FacebookShareButton url={socialConfig.config.url}>
      <Button color="facebook">
        <Icon name="facebook" /> Facebook
      </Button>
    </FacebookShareButton>
    <TwitterShareButton
      url={socialConfig.config.url}
      title={socialConfig.config.title}
      via={socialConfig.twitterHandle.split("@").join("")}
      hashtags={tags}
    >
      <Button color="twitter">
        <Icon name="twitter" /> Twitter
      </Button>
    </TwitterShareButton>
    <LinkedinShareButton url={socialConfig.config.url}>
      <Button color="linkedin">
        <Icon name="linkedin" /> LinkedIn
      </Button>
    </LinkedinShareButton>
    <RedditShareButton
      url={socialConfig.config.url}
      className="button is-outlined is-rounded reddit"
      title={socialConfig.config.title}
    >
      <Button color="orange">
        <Icon name="reddit" /> Reddit
      </Button>
    </RedditShareButton>
  </>
)

ShareFooter.propTypes = {
  socialConfig: PropTypes.shape({
    twitterHandle: PropTypes.string.isRequired,
    config: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
}
ShareFooter.defaultProps = {
  tags: [],
}

export default ShareFooter
